import { createContext } from 'react';

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { PickerItem } from "@/@types/controls/controls";

export type OperationsContextType = {
    projectItems: Array<PickerItem>;
    selectedProject: DCRecord | null
    selectProject: (id: number | null) => void

    fishnetItems: Array<PickerItem>;
    selectedFishnet: DCRecord | null;
    selectFishnet: (id: number | null) => void
}

const defaultOperationsContext = {
    projectItems: [],
    selectedProject: null,
    selectProject: (id: number | null) => {},

    fishnetItems: [],
    selectedFishnet: null,
    selectFishnet: (id:number | null) => {}
}

const OperationsContext = createContext<OperationsContextType>(defaultOperationsContext);
OperationsContext.displayName = 'OperationsContext';

export default OperationsContext
